import { render, staticRenderFns } from "./PreprintContent.vue?vue&type=template&id=d4b9b02a"
import script from "./PreprintContent.vue?vue&type=script&lang=js"
export * from "./PreprintContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports